import * as React from 'react';
import {
    List,
    EditButton,
    Datagrid,
    TextField,
    useRecordContext,
    NumberField,
    Filter,
    TextInput,
    SelectInput,
    useNotify,
    FieldProps,
    useDataProvider,
    ShowButton,
    useListContext,
} from 'react-admin';
import ThumbnailField from '../../common/ThumbnailField';
import SubjectsLinkField from './SubjectsLinkField';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import TestSeriesesLinkField from './TestSeriesesLinkField';
import { DeleteWithDialogAction } from '../../common/DeleteWithDialogAction';
import StatusTags from '../../common/StatusTags';
import ContentCounts from '../../common/ContentCounts';
import { CLASSES, EXAMS, LANGUAGES, STATUS } from '../../common/constants';
import { Programs, Subjects } from '../../custom';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import ClearFiltersOnRouteChange from '../../common/ClearFiltersOnRouteChange';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const ClassTextField = ({ source }: { source: string, sortable?: boolean }) => {
    const record = useRecordContext();
    return (
        <span className="flex flex-col text-xs">
            <p>
                Class: <strong>{record && record[source]?.class}</strong>,
            </p>
            <p>
                Exam: <strong>{record && record[source]?.exam}</strong>,
            </p>
            <p>
                Language: <strong>{record && record[source]?.language}</strong>
            </p>
        </span>
    );
};

const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
        <SelectInput source="status" label={'Status'} choices={STATUS} alwaysOn />
    </Filter>
);

const ProgramList = () => {
    const { isUpdatable, isDeletable, isWritable } = useIsPermission('PROGRAM');

    return (
        <List
            filters={<ListFilter />}
            actions={<PermissionBasedActions isWritable={isWritable} />}
            sort={{ field: 'created_at', order: 'DESC' }}
            queryOptions={{
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            }}
        >
            <ClearFiltersOnRouteChange />
            <Datagrid bulkActionButtons={false}>
                <TextField source="name" className="" sortable={false} />
                <StatusTags source="status" label={'Status'} sortable={false} />
                <NumberField source="displayOrder" sortable />
                <ClassTextField source="config" sortable={false} />
                <ContentCounts />
                <FormattedDateTimeField source="createdAt" sortable />
                <TestSeriesesLinkField />
                <SubjectsLinkField />
                <div className="flex">
                    <ShowButton />
                    {isUpdatable && <EditButton />}
                    {isDeletable && <ConfirmDeleteButton />}
                </div>
            </Datagrid>
        </List>
    );
};

export default ProgramList;
